import {createSelector} from "@reduxjs/toolkit";
import {authStateSelector, authStatusSelector, activationStatusSelector} from "./authSlice";

export const selectAuthState = createSelector([authStateSelector], state => state);
export const selectIsAuthenticated = createSelector([authStateSelector], state => state?.isAuthenticated);
export const selectIsAuthenticating = createSelector([authStateSelector], state => state?.isAuthenticating);
export const selectIsLoggingOut = createSelector([authStateSelector], state => state?.isLoggingOut);
export const selectAuthStatus = createSelector([authStatusSelector], status => status);
export const selectAuthErrorMsg = createSelector([authStateSelector], state => state?.errorMsg);
export const selectAuthIsFetching = createSelector([authStateSelector], state => state?.isFetching);
export const selectAuthHasFailed = createSelector([authStateSelector], state => state?.hasFailed);
export const selectToken = createSelector([authStateSelector], state => state?.token);
export const selectGrantPermissionToPartner = createSelector(
  [authStateSelector],
  state => state?.grantPermissionToPartner,
);
export const selectActivationStatus = createSelector([activationStatusSelector], activationStatus => activationStatus);
